import * as yup from "yup"
import { formCustomerQuotationDetailSchema } from "./FormCustomerQuotationDetail"
import { formReminderSchema } from "./FormReminder"

export type FormCustomerQuotationType = yup.InferType<typeof formCustomerQuotationSchema>

export const formCustomerQuotationSchema = yup.object().shape({
  customer_quotation_id: yup.number().label("Customer Quotation").optional(),
  customer_id: yup
    .number()
    .label("Customer") 
    .typeError("Customer is required")
    .required(),
  customer_name: yup.string().label("Customer").optional(),
  employee_id: yup
    .number()
    .label("Employee")
    .typeError("Employee is required")
    .required(),
  payment_term: yup
    .number()
    .label("Payment Term")
    .typeError("Please fill Customer Payment Term")
    .required("Please fill Customer Payment Term"),
  payment_term_name: yup.string().label("Payment Term").optional(),
  price_level_name: yup
    .string()
    .label("Price Level")
    .required("Please fill Customer Price Level"),
  location_id: yup
    .number()
    .label("Location")
    .typeError("Location is required")
    .required(),
  tax_inclusive: yup.boolean().label("Tax Inclusive").required(),
  shipped: yup.string().label("Shipped").required(),
  memo: yup.string().label("Memo").required(),
  trx_code: yup.string().label("Code").optional(),
  transaction_date: yup.string().label("Transaction Date").required(),
  referensi: yup.string().label("Referensi").required(),
  promize_date: yup.string().label("Promise Date").required(),
  freight: yup.number().label("Freight").optional(),
  approved_by: yup.string().label("Approved By").optional(),
  approved_by_name: yup.string().label("Approved By").optional(),
  approval_status: yup.number().label("Approved By").defined(),
  approval_status_text: yup.string().label("Approved By").defined(),
  detail: yup
    .array()
    .of(formCustomerQuotationDetailSchema)
    .min(1)
    .label("Sales order detail")
    .required(),
  reminder: formReminderSchema.nullable(),
  imgPath: yup.array().of(yup.object().shape({
    file_path: yup.string().required(),
  })).label("FILE").min(0).optional()
})
